<template>
	<div>
		<!-- 顶部显示的页面 -->
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
			<el-breadcrumb-item>店铺管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div>
			<el-button type="primary" @click="NewlyAdded">添加店铺</el-button>
		</div>
		<div style="margin-top:20px">
			<el-table :data="tableList" style="width: 100%" v-loading="loading" element-loading-text="拼命加载中">
				<el-table-column label="店铺名称" prop="shop_name"></el-table-column>
				<el-table-column label="店铺地址" prop="shop_address"/>
				<el-table-column label="景区名称" prop="area_name"/>
				<el-table-column label="创建时间" width="150" prop="create_date"></el-table-column>
				<el-table-column label="操作" width="260">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" @click="bundle(scope.row)">查看员工</el-button>
						<el-button type="primary" size="mini" @click="edit(scope.row)">修改</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 分页 -->
		<div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						   :current-page="currentPage" :page-sizes="[10, 20, 30, 40]"
						   :page-size="queryList.pageSize" layout="total,  prev, pager, next, jumper"
						   :total="total"
						   style="text-align:right;margin:0 16px 10px 0;border-radius:20px"></el-pagination>
		</div>
	</div>
</template>

<script>
import qs from "qs";
import coupon from "../api/coupons";

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10
		}
	},
	data() {
		return {
			loading:true,
			tableData: [],
			scenicAll: [],
			input: '',
			currentPage: 1,   //分页
			total: 0,        //分页
			tableList: [],
			editDialogVisible: false,   //商品编辑的弹框
			editInfo: [],               //商品编辑的数据集合
			input1: '',               //景区名称
			input2: '',               //景区原价格
			input3: '',                //景区套餐价格
			packagePriceNumber: [],     //套餐价格输入框
			packageId: 0,
			packageName: '',
			queryList: {
				pageindex: 1,
				pagesize: 10,
				orderby: undefined,
				count: true
			}
		}
	},
	mounted() {
		this.getCouponShopList();
	},
	filters: {
		state(state) {
			switch (state) {
				case '0':
					return '已售完';
				case '1':
					return '上架';
				case '2':
					return '下架';
			}
		}
	},
	methods: {
		getCouponShopList() {
			coupon.getCouponShopList(this.queryList).then(res => {
				this.tableList = res.list;
				this.total = res.totalcount;
				this.loading=false;
			})
		},
		// 新增按钮的方法
		NewlyAdded() {
			this.$router.push({
				path: "/shopAdd",
				query: {type: 0}
			});
		},
		getAllScenic() {
			this.$axios.postRequest({
				methodUrl: "admin/getScenicArea",
				jsonParam: qs.stringify({
					pageindex: 1,
					pagesize: 1000,
				})
			}).then(
					res => {
						//成功之后处理逻辑
						this.scenicAll = res.data.list
					},
			)
		},
		// 用户编辑
		edit(row) {
			this.$datas.shop.id = row.id;
			this.$datas.shop.info = row;
			this.$router.push({
				path: "/shopAdd",
				query: {type: 1}
			});
		},
		bundle(row) {//查看
			this.$datas.shop.id = row.id;
			this.$router.push({
				path: "/staffList",
				query: {}
			});
		},
		operate(row) {//上下架
			let package_status = row.package_status !== 1 ? 1 : 2;
			coupon.updateCouponPackageStatus({id: row.id, package_status}).then(res => {
				this.getCouponPackageList();
			}).catch(err => {
				this.$confirm(err.msg || '系统错误', '提示', {
					confirmButtonText: '确定',
					showCancelButton: false,
					type: 'warning'
				})
			})
		},
		del(row) {
			let id = row.id;
			this.$confirm('确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				coupon.deleteCouponPackage({id}).then(res => {
					this.getCouponPackageList();
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				})
			})
		},
		scenicSelect(index, row) {
			this.$axios.postRequest({
				methodUrl: "admin/getScenicArea",
				jsonParam: qs.stringify({
					area_id: row.area_id,
				}),
			}).then(
					res => {
						const list = res.data.list
						if (list && list.length > 0) {
							this.bulletList[index].original_price = list[0].voice_price
						}
					},
			)
		},
		handleDeletePackageLine(index) {
			this.bulletList.splice(index, 1)
		},
		// 分页
		handleSizeChange(val) {
			this.queryList.pageSize = val;
			this.getCouponPackageList();
		},
		handleCurrentChange(val) {
			this.queryList.pageindex = val;
			this.getCouponPackageList();
		},

		// 表格
		// handleEdit (index, row) {
		//   console.log(index, row);
		// },
		// handleDelete (index, row) {
		//   console.log(index, row);
		// }
		ViewDetails(index, row) {
		}
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shopManage.vue